module.exports = __webpack_public_path__ + "img/lens-167-plus-01.5c949d9e.png";